// src/components/Hero.js
import React, { useEffect, useState } from "react";
import "./Hero.css";
import { Link } from "react-router-dom";
import defaultHeroBg from "../assets/hero-background.png";

import { db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";
import { getStorage, ref, getDownloadURL } from "firebase/storage";

const storage = getStorage();

function looksLikeStoragePath(s) {
  if (!s) return false;
  // allow gs://... or plain storage-ish paths like "home/hero.jpg"
  return s.startsWith("gs://") || (!s.startsWith("http://") && !s.startsWith("https://"));
}

async function resolveImageURL(maybePathOrUrl) {
  if (!maybePathOrUrl) return null; // tell caller to use 'none'
  if (looksLikeStoragePath(maybePathOrUrl)) {
    const clean = maybePathOrUrl.replace(/^gs:\/\/[^/]+\//, "");
    try {
      const url = await getDownloadURL(ref(storage, clean));
      return url;
    } catch {
      return null; // treat missing/bad paths as no image
    }
  }
  return maybePathOrUrl; // already a URL
}

const Hero = () => {
  const [hero, setHero] = useState({
    heading: "Designing Experiences.\nCrafting Memories.",
    subheading:
      "Turning Ideas Into Impact – UI/UX Design, Content Creation, Handmade Gifts.",
    backgroundImage: null, // null means no image -> 'none'
    button1Text: "View My Work",
    button1Link: "/portfolio",
    button2Text: "Explore Services",
    button2Link: "/services",
  });

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const snap = await getDoc(doc(db, "pageContent", "homeHero"));
        if (!mounted) return;
        if (snap.exists()) {
          const d = snap.data() || {};
          const bgURL = await resolveImageURL(d.backgroundImage);
          if (!mounted) return;
          setHero((h) => ({
            ...h,
            heading: d.heading || h.heading,
            subheading: d.subheading || h.subheading,
            backgroundImage: bgURL, // can be null when empty/invalid
            button1Text: d.button1Text || h.button1Text,
            button1Link: d.button1Link || h.button1Link,
            button2Text: d.button2Text || h.button2Text,
            button2Link: d.button2Link || h.button2Link,
          }));
        }
      } catch (e) {
        if (process.env.NODE_ENV === "development") {
          console.warn("[Hero] Firestore read failed; using defaults", e);
        }
      }
    })();
    return () => { mounted = false; };
  }, []);

  const {
    heading,
    subheading,
    backgroundImage,
    button1Text,
    button1Link,
    button2Text,
    button2Link,
  } = hero;

  return (
    <section
      className="hero"
      style={{
        backgroundImage: backgroundImage ? `url(${backgroundImage})` : "none",
      }}
    >
      <div className="hero-content">
        <h1>
          {heading.split("\n").map((line, idx) => (
            <React.Fragment key={idx}>
              {line}
              <br />
            </React.Fragment>
          ))}
        </h1>
        <p>{subheading}</p>
        <div className="hero-buttons">
          <Link to={button1Link}>{button1Text}</Link>
          <Link to={button2Link}>{button2Text}</Link>
        </div>
      </div>
    </section>
  );
};

export default Hero;
